import styled from "styled-components";

const green = "#019A32";
const darkGreen = "#08783b";

export const MainDiv = styled.div`
    width: 100%;
    min-height: 100%;
    padding: 20px;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    gap: 16px;

    font-family: "Segoe UI", sans-serif;
    color: #25342b;
    background: #f5f8f6;

    @media (max-width: 768px) {
        padding: 10px;
        gap: 12px;
    }
`;

export const LineDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;

    padding: 8px 13px;
    min-height: 36px;
    box-sizing: border-box;

    background: ${({ $selected }) =>
    $selected ? "#e3f5e9" : "#ffffff"};

    border: 1px solid ${({ $selected }) =>
    $selected ? green : "#e1e7e3"};

    border-radius: 8px;
    color: ${({ $selected }) =>
    $selected ? darkGreen : "#374151"};

    font-size: 13px;
    font-weight: ${({ $selected }) =>
    $selected ? 600 : 400};

    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;

    input {
        accent-color: ${green};
        pointer-events: none;
        margin: 0;
    }

    &:hover {
        border-color: ${green};
        background: #eaf8ef;
    }
`;

export const Text = styled.span`
    font-size: 13px;
    color: inherit;
`;

export const SectionDiv = styled.div`
    display: ${({ $visible }) =>
            $visible ? "flex" : "none"};

    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px;

    padding: 14px;
    width: 100%;
    box-sizing: border-box;

    background: white;
    border: 1px solid #e2e8e5;
    border-radius: 12px;

    pointer-events: ${({ $clickable }) =>
            $clickable ? "auto" : "none"};

    box-shadow: 0 3px 12px rgba(0,0,0,0.03);
`;

export const SelectorsDiv = styled.div`
    display: ${({ $visible }) =>
            $visible ? "flex" : "none"};

    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;

    padding: 10px;
    width: 100%;
    box-sizing: border-box;

    background: white;
    border: 1px solid #e2e8e5;
    border-radius: 12px;
`;

export const SelectorDiv = styled.button`
    min-width: 120px;
    min-height: 42px;
    padding: 10px 16px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: ${({ $active }) =>
    $active ? darkGreen : "#f4f7f5"};

    color: ${({ $active }) =>
    $active ? "white" : "#475569"};

    border: 1px solid ${({ $active }) =>
    $active ? darkGreen : "#e2e8e5"};

    border-radius: 9px;

    font-family: "Segoe UI", sans-serif;
    font-size: 13px;
    font-weight: 600;

    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: ${({ $active }) =>
    $active ? "#076431" : "#eaf8ef"};
        border-color: ${green};
    }

    @media (max-width: 480px) {
        flex: 1;
        min-width: 0;
        padding: 9px 10px;
    }
`;

export const ButtonsDiv = styled.div`
    display: ${({ $visible }) =>
    $visible ? "flex" : "none"};

    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;

    width: 100%;
    padding: 12px 0;
    box-sizing: border-box;
`;

export const Button = styled.button`
    min-width: 110px;
    min-height: 40px;
    padding: 10px 20px;

    border: 1px solid ${green};
    border-radius: 9px;

    background: ${({ $secondary }) =>
    $secondary ? "white" : green};

    color: ${({ $secondary }) =>
    $secondary ? green : "white"};

    font-family: "Segoe UI", sans-serif;
    font-size: 13px;
    font-weight: 600;

    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: ${({ $secondary }) =>
    $secondary ? "#eaf8ef" : "#08783b"};

        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(1,154,50,0.15);
    }

    &:active {
        transform: scale(0.98);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const PercentText=styled.text`    
    color:  red;
`